import React from 'react';
import type { TreeMenuItem, useLink } from '@refinedev/core';
import * as Styles from './styles';
import { getIcon } from './helpers';
import { Typography } from 'antd';

type LinkComponent = ReturnType<typeof useLink>;

type Props = {
  item: TreeMenuItem;
  selectedKey?: string | null;
  Link: LinkComponent;
};

const PanelContent: React.FC<Props> = ({ item, selectedKey, Link }) => {
  const isNodeKeyActive = (node: TreeMenuItem, selected?: string | null) => {
    if (!selected) return false;
    return selected === node.key;
  };
  return (
    <>
      <Typography.Title
        level={5}
        style={{ marginBottom: 8, letterSpacing: '2px' }}
        className="font-gloock"
      >
        {item.label ?? item.name}
      </Typography.Title>
      <Styles.PanelList>
        {item.children?.map(child => {
          const ChildIcon = getIcon(child);
          const isChildActive = isNodeKeyActive(child, selectedKey);
          return (
            <Link to={child.list ?? child.route ?? ''} key={child.key} style={{ color: 'inherit' }}>
              <Styles.PanelItem $active={isChildActive}>
                <Styles.PanelItemIcon>{ChildIcon}</Styles.PanelItemIcon>
                <span>{child.label ?? child.name}</span>
              </Styles.PanelItem>
            </Link>
          );
        })}
      </Styles.PanelList>
    </>
  );
};

export default PanelContent;
